import {useEffect, useState} from "react"
import SearchIcon from "@mui/icons-material/Search"
import ClearIcon from "@mui/icons-material/Clear"
import {IconButton, InputAdornment, TextField} from "@mui/material"

interface SearchProps {
	searchTerm: string
	label: string
	onSearch: (searchText: string) => void
	width: string | number
}

export default function Search(props: SearchProps) {
	const [searchText, setSearchText] = useState(props.searchTerm)
	useEffect(() => {
		setSearchText(props.searchTerm)
	}, [props.searchTerm])

	const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setSearchText(event.target.value)
		props.onSearch(event.target.value)
	}

	const handleClearSearch = () => {
		setSearchText("")
		props.onSearch("")
	}

	return (
		<TextField
			variant="outlined"
			label={props.label}
			value={searchText}
			onChange={handleSearchChange}
			InputProps={{
				endAdornment: (
					<InputAdornment
						position="end"
						sx={{
							"& .MuiOutlinedInput-root": {
								boxSizing: "unset !important",
							},
							"& .MuiInputBase-input": {
								boxSizing: "unset !important",
							},
							"& .MuiInputBase-input:focus": {
								boxShadow: "none !important",
							},
						}}
					>
						{searchText ? (
							<IconButton
								style={{
									padding: "unset",
								}}
								onClick={handleClearSearch}
							>
								<ClearIcon />
							</IconButton>
						) : (
							<IconButton
								style={{
									padding: "unset",
								}}
							>
								<SearchIcon />
							</IconButton>
						)}
					</InputAdornment>
				),
			}}
			size="small"
			style={{
				width: props.width || "324px",
			}}
		/>
	)
}
